// extracted by mini-css-extract-plugin
export default {"products":"products_products__ZMf2n","lead":"products_lead__ao0dH","loading":"products_loading__gpCCP","text":"products_text__lKJ7t","error":"products_error__MKGfI"};